var map = {
	"./bg-kalender-2.jpg": 2288,
	"./bg-kalender-2.webp": 1067,
	"./bg-kalender-card-1.jpg": 9554,
	"./bg-kalender-card-1.webp": 7208,
	"./bg-kalender-card-10.jpg": 7786,
	"./bg-kalender-card-10.webp": 2052,
	"./bg-kalender-card-11.jpg": 9558,
	"./bg-kalender-card-11.webp": 4789,
	"./bg-kalender-card-12.jpg": 7599,
	"./bg-kalender-card-12.webp": 1197,
	"./bg-kalender-card-13.jpg": 4449,
	"./bg-kalender-card-13.webp": 3808,
	"./bg-kalender-card-14.jpg": 4952,
	"./bg-kalender-card-14.webp": 5918,
	"./bg-kalender-card-15.jpg": 7373,
	"./bg-kalender-card-15.webp": 8416,
	"./bg-kalender-card-16.jpg": 3607,
	"./bg-kalender-card-16.webp": 4166,
	"./bg-kalender-card-17.jpg": 9434,
	"./bg-kalender-card-17.webp": 7419,
	"./bg-kalender-card-18.jpg": 7676,
	"./bg-kalender-card-18.webp": 7191,
	"./bg-kalender-card-19.jpg": 1216,
	"./bg-kalender-card-19.webp": 7376,
	"./bg-kalender-card-2.jpg": 3177,
	"./bg-kalender-card-2.webp": 1937,
	"./bg-kalender-card-20.jpg": 2883,
	"./bg-kalender-card-20.webp": 5222,
	"./bg-kalender-card-21.jpg": 9234,
	"./bg-kalender-card-21.webp": 4265,
	"./bg-kalender-card-22.jpg": 8939,
	"./bg-kalender-card-22.webp": 7542,
	"./bg-kalender-card-23 - Kopie.jpg": 5805,
	"./bg-kalender-card-23 - Kopie.webp": 7020,
	"./bg-kalender-card-23.jpg": 8442,
	"./bg-kalender-card-23.webp": 2444,
	"./bg-kalender-card-24.jpg": 5741,
	"./bg-kalender-card-24.webp": 7954,
	"./bg-kalender-card-25.jpg": 2839,
	"./bg-kalender-card-25.webp": 1593,
	"./bg-kalender-card-26.jpg": 8352,
	"./bg-kalender-card-26.webp": 2046,
	"./bg-kalender-card-27.jpg": 5724,
	"./bg-kalender-card-27.webp": 2734,
	"./bg-kalender-card-28 - Kopie.jpg": 668,
	"./bg-kalender-card-28 - Kopie.webp": 2552,
	"./bg-kalender-card-28.jpg": 2448,
	"./bg-kalender-card-28.webp": 3278,
	"./bg-kalender-card-29.jpg": 5697,
	"./bg-kalender-card-29.webp": 1086,
	"./bg-kalender-card-3.jpg": 2157,
	"./bg-kalender-card-3.webp": 342,
	"./bg-kalender-card-4.jpg": 7261,
	"./bg-kalender-card-4.webp": 7219,
	"./bg-kalender-card-5.jpg": 1634,
	"./bg-kalender-card-5.webp": 8188,
	"./bg-kalender-card-6.jpg": 8509,
	"./bg-kalender-card-6.webp": 3215,
	"./bg-kalender-card-7.jpg": 3060,
	"./bg-kalender-card-7.webp": 7000,
	"./bg-kalender-card-8.jpg": 951,
	"./bg-kalender-card-8.webp": 4282,
	"./bg-kalender-card-9.jpg": 1277,
	"./bg-kalender-card-9.webp": 3815,
	"./close.png": 2266,
	"./close.webp": 8149,
	"./elch.png": 7797,
	"./geschenk-2.png": 9072,
	"./geschenk.png": 8430,
	"./glaeser.png": 7066,
	"./kreis-hoch.png": 8569,
	"./kreis.png": 5249,
	"./kugel-2.png": 225,
	"./kugel-rot.png": 3801,
	"./logo-medienpaedagogisches-zentrum-mittelsachsen.png": 902,
	"./logo-medienpaedagogisches-zentrum-mittelsachsen.webp": 4334,
	"./logo-mittelsaechsische-kultur.png": 9807,
	"./logo-mittelsaechsische-kultur.webp": 8879,
	"./logo-musikschule-mittelsachsen.png": 1386,
	"./logo-musikschule-mittelsachsen.webp": 9551,
	"./logo-schloss-rochsburg.png": 2626,
	"./logo-schloss-rochsburg.webp": 5041,
	"./logo-volkshochschule-mittelsachsen.png": 7587,
	"./logo-volkshochschule-mittelsachsen.webp": 1857,
	"./mistel.png": 4459,
	"./schneemann.png": 6347,
	"./stern-1-gruen.png": 8374,
	"./stern-1-weiss.png": 4349,
	"./sterne-3-weiss-hoch.png": 9570,
	"./sterne-3-weiss.png": 3167,
	"./stiefel.png": 2515,
	"./tanne.png": 1562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;